// FYI
// packages/@guardian/src-foundations/src/utils/supports-queries.ts SYMLINKS TO
// packages/@guardian/source-foundations/src/utils/supports-queries.ts
export const appearance = '(appearance: none) or (-webkit-appearance: none) or (-moz-appearance: none)';
//# sourceMappingURL=supports-queries.js.map
